export default "__VITE_ASSET__2Rg56dkj__"